import { render, staticRenderFns } from "./number-input.vue?vue&type=template&id=fa82024a&scoped=true"
import script from "./number-input.vue?vue&type=script&lang=ts"
export * from "./number-input.vue?vue&type=script&lang=ts"
import style0 from "./number-input.vue?vue&type=style&index=0&id=fa82024a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa82024a",
  null
  
)

export default component.exports